export default {
  // 多租户用的同一套代码，区别多租户的不同配置
  tenant: {
    1: {
      install: { // app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    2: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    3: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '3109335',
          'channelCode': '',
          'iosAppid': 'com.testApp.newcsylc', // ios包名
          'andAppid': 'com.elotandroid_newcsylc', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    4: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    5: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    6: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    7: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '', // 之前的值：f355543ada8a6bce
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    8: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    9: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: '',
    },
    10: {
      install: { //app下载推广配置
        used: 'shareTraceInstall', // 值为：openinstall、shareinstall、shareTraceInstall
        // install 推荐渠道的key值
        openinstall: '',
        shareinstall: '',
        shareTraceInstall: '',
        downloadPage: { // 这个是用于配死推荐码的
          'code': '',
          'channelCode': '',
          'iosAppid': 'com.testApp.nyscnqp1', // ios包名
          'andAppid': 'com.elotandroid_nyscnqp1', // android包名
        }
      },
      // 维护界面的客服地址
      repairKF: ''
    },
  },
  // 根据国家标识显示对应的钱的符号 如 CNY: '¥' 默认为 ''
  goldMark: {
    CNY: '¥', // 中国
    THB: '฿', // 泰国
    VND: '₫', // 越南
    INR: '₹', // 印度
    MYR: 'RM', // 马来
    IDR: 'Rp', // 印尼
    USD: '$', // 美国
    BTR: 'R$', // 巴西
  }
}